import React from "react";

import * as colors from "../helpers/constants/colors";
import { greyPalette } from "../helpers/constants/colorPalettes";
import Button from "./Button";
import Close from "material-ui-old/svg-icons/navigation/close";
import { MuiThemeProvider } from "material-ui-old/styles";
import { notificationConstants } from "../modules/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Notification extends React.PureComponent {
    componentDidMount() {
        const { dismissInterval, dismiss } = this.props;
        setTimeout(dismiss, dismissInterval);
    }

    render() {
        const { message, icon, level, button, style, dismiss } = this.props;
        let backgroundColor;
        let textColor;
        switch (level) {
            case notificationConstants.NOTIFICATION_LEVEL_INFO:
                backgroundColor = colors.notifications.palette.blue;
                textColor = colors.primary;
                break;
            case notificationConstants.NOTIFICATION_LEVEL_ERROR:
                backgroundColor = colors.notifications.palette.red;
                textColor = colors.error;
                break;
            case notificationConstants.NOTIFICATION_LEVEL_SUCCESS:
                backgroundColor = colors.notifications.palette.green;
                textColor = colors.secondary;
                break;
            default:
                backgroundColor = colors.notifications.palette.blue;
                textColor = colors.primary;
                break;
        }
        return (
            <MuiThemeProvider>
                <div
                    style={{
                        width: "100%",
                        background: backgroundColor,
                        height: "50px",
                        display: "flex",
                        color: textColor,
                        justifyContent: "center",
                        ...style
                    }}
                >
                    <div
                        style={{
                            order: "1",
                            margin: "auto",
                            height: "100%",
                            display: "flex",
                            flexDirection: "row"
                        }}
                    >
                        {icon ? (
                            <div
                                style={{
                                    order: 1,
                                    height: "2rem",
                                    width: "2rem",
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                    marginRight: "5px"
                                }}
                            >
                                <FontAwesomeIcon icon={icon} size="2x" />
                            </div>
                        ) : (
                            ""
                        )}
                        <h5
                            style={{
                                order: 2,
                                marginLeft: "5px",
                                marginRight: "5px",
                                marginTop: "auto",
                                marginBottom: "auto"
                            }}
                        >
                            {message}
                        </h5>
                        {button && button.text && button.props ? (
                            <div
                                style={{
                                    order: 3,
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                    marginLeft: "40px"
                                }}
                            >
                                <Button {...button.props}>{button.text}</Button>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>

                    <div
                        style={{
                            order: 4,
                            cursor: "pointer",
                            height: "24px",
                            marginRight: "5px",
                            marginTop: "auto",
                            marginBottom: "auto",
                            alignSelf: "flex-end"
                        }}
                        onClick={dismiss}
                    >
                        <Close color={greyPalette.medGrey} />
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notification.js